import { useQuery } from "@tanstack/react-query";
import http_payroll from "../../utils/http_payroll";
import { Api_EndPoints } from "../../utils/Api_EndPoints";

const getDesignations = async ({companyCode, isTrue=true}) => {
  const data = await http_payroll.get(
    `${Api_EndPoints.GetDesignations}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

export const useGetAllDesignationQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetDesignations],
    queryFn: () => getDesignations(input),
    refetchOnWindowFocus: false,
    
  });
};
